import "../css/searchbar.css";
import { ReactComponent as SearchIcon } from "../assets/icons/search.svg";


const SearchBar = ({ label }) => {

    return(
        <div className="search-bar">
            <SearchIcon />
            <input type="text" placeholder={label} />
        </div>
    )
}

export default SearchBar;